import { render, staticRenderFns } from "./OPDetailReport.vue?vue&type=template&id=67ced13e&"
import script from "./OPDetailReport.vue?vue&type=script&lang=js&"
export * from "./OPDetailReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports